import type { ConnectionState } from '../../types/ble';

const STATE_LABELS: Record<ConnectionState, string> = {
  disconnected: 'Disconnected',
  scanning: 'Scanning',
  connecting: 'Connecting',
  connected: 'Connected',
  reconnecting: 'Reconnecting',
  error: 'Error',
};

const STATE_DOT: Record<ConnectionState, string> = {
  disconnected: 'disconnected',
  scanning: 'reconnecting',
  connecting: 'reconnecting',
  connected: 'connected',
  reconnecting: 'reconnecting',
  error: 'error',
};

export default function StatusBadge({ state }: { state: ConnectionState }) {
  return (
    <div className="flex items-center gap-1.5">
      <div className={`status-dot ${STATE_DOT[state]}`} />
      <span className="text-[10px] readout text-gray-400">{STATE_LABELS[state]}</span>
    </div>
  );
}
